import {mmcAjax} from '@/common/js/mmcModule';

export function getWithdrawals(page) {
    return mmcAjax({
        method: 'GET',
        url: `${window.APIBasePath}mmc/user-center/withdrawals/list/${page}`,
        crossDomain: true,
    })
}
